import { useContext } from 'react';
import { ShortcutContext } from '../shortcut-provider';
export default function useRegisterHotkeys() {
  return useContext(ShortcutContext);
}